<template>
    <div class="box is-flex is-flex-direction-column has-gap-large">
        <div class="is-flex is-align-items-center has-gap-medium">
            <Field
                is="checkbox"
                v-model="selected"
                :disabled="props.selectDisabled"
                class="mb-0 is-large"
            />

            <div class="box-title m-0">
                Order #{{ fulfillmentOrder.orderId }}
            </div>
        </div>

        <Link
            :href="route('admin.self_fulfillment.orders.show', { fulfillmentOrder: props.fulfillmentOrder.id })"
            class="is-flex is-flex-direction-column has-gap-large"
        >
            <AppOrder
                :order="fulfillmentOrder.order"
                hide-header
                hide-footer
            />

            <div
                class="block is-flex is-align-items-baseline is-size-6 is-flex-wrap-wrap"
                style="row-gap: .5rem; column-gap: 3rem;"
            >
                <span
                    class="tag is-capitalized"
                    :class="orderStatus.colorClass"
                >
                    {{ orderStatus.text }}
                </span>
            </div>
        </Link>
    </div>
</template>

<script setup lang="ts">
import {FulfillmentOrder} from "@/Types/FulfillmentOrder";
import {Link} from "@inertiajs/vue3";
import AppOrder from "@/Components/AppOrder.vue";
import {computed} from "vue";
import Field from "@/Components/common/Field.vue";

const props = defineProps<{
    fulfillmentOrder: FulfillmentOrder
    selectDisabled?: boolean
}>();

const selected = defineModel<boolean>('selected', {
    required: false,
    default: false,
});

const orderStatus = computed<{text: string, colorClass: string}>(() => {
    if (props.fulfillmentOrder.dateShipped) {
        return {text: 'Shipped', colorClass: 'is-success'};
    } else if (props.fulfillmentOrder.datePostagePurchased) {
        return {text: 'Pending Shipment', colorClass: 'is-info'};
    } else {
        return { text: 'Pending Postage', colorClass: 'is-warning' };
    }
});
</script>
